export default {
  Student: {
    DateOfBirthWithValue: 'Ngày sinh: {date}',
    SISAPCode: 'Mã SISAP: {code}',
    CreatedAccount: 'Đã tạo tài khoản',
    StudentGradeID: 'ID khối của học sinh',
    Tutorial: 'Em nhờ bố mẹ mở ứng dụng <b>SISAP Phụ Huynh</b> để xem lại tài khoản, hoặc sử dụng Số điện thoại, Mã SISAP để lấy lại tài khoản nhé!<br/><span class="text-accent-200 cursor-pointer {className}">Xem hướng dẫn chi tiết</span>',
    PhoneNumberNotFound: 'Tài khoản của bạn chưa khai báo thông tin số điện thoại. Vui lòng liên hệ giáo viên chủ nhiệm của bạn để lấy lại tài khoản, mật khẩu.'
  }
}
